import { FormikInput } from '@/components/forms';

import { Contract, EventType } from '../../../domain';
import { AbiFunctionDTO, CreatedContractsDTO } from '../../../infra/dtos';
import SelectTriggerArgument from './select-trigger-argument';

interface Props {
  contract: CreatedContractsDTO | Contract;
  selectedFunctionOrEvent: AbiFunctionDTO;
  inputName: 'volumeArgument' | 'revenueArgument' | 'currencyVolumeArgument' | 'currencyRevenueArgument';
  type: EventType;
}

export default function DefineTriggerArgumentExpression(props: Props) {
  const { inputName } = props;

  return (
    <div className="tw:flex tw:flex-row tw:gap-4 tw:py-2">
      <FormikInput name={`${inputName}.percentage`} type="number" label="Percentage" rightSlot={<span>%</span>} />
      <SelectTriggerArgument {...props} inputName={inputName} />
    </div>
  );
}
